import * as React from 'react';
import styled, { css } from 'styled-components';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { safelyRender } from '@/utils/safelyRender';

type Props = {
    label: string;
    last?: boolean;
    target?: string;
    type: string;
};

const ensureTrailingSlash = (target: string) => {
    return target.endsWith('/') ? target : `${target}/`;
};

const Breadcrumb = (props: Props) => {
    const { label = '', last = false, target = '', type = 'label' } = props;
    const safeLabel = safelyRender(label, 'span');

    return (
        <StyledBreadcrumb>
            <StyledWrapper ellipsis={label?.length > 32}>
                {type === 'anchor' && (
                    <Link primaryWeak to={ensureTrailingSlash(target)}>
                        {safeLabel}
                    </Link>
                )}
                {type === 'label' && <div className="pull-left">{safeLabel}</div>}
                {type === 'link' && (
                    <Link primaryWeak route to={ensureTrailingSlash(target)}>
                        {safeLabel}
                    </Link>
                )}
                {!last && <StyledChevron>&rsaquo;</StyledChevron>}
            </StyledWrapper>
        </StyledBreadcrumb>
    );
};

export default React.memo<Props>(Breadcrumb);

interface WrapperProps {
    ellipsis: boolean;
}

const StyledBreadcrumb = styled.li`
    padding: 0 7px 0 0;
    display: inline-block;
    vertical-align: middle;
    color: ${({ theme }) => theme.colors.grey100};
    line-height: 17px;
`;

const StyledWrapper = styled.div<WrapperProps>`
    && {
        max-width: 240px;
        height: 17px;
        max-height: 17px;
        display: flex;

        a {
            flex: 1 1 auto;
            width: calc(100% - 13px);
        }

        ${({ ellipsis }) => {
            return ellipsis
                ? css`
                      a,
                      div {
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          overflow: hidden;
                          display: inline-block;
                          width: calc(100% - 15px);
                      }
                  `
                : '';
        }}
    }
`;

const StyledChevron = styled.span`
    margin-left: 7px;
    line-height: 13px;
    font-size: 20px;
    display: inline-block;
    vertical-align: -1px;
`;
